'use client';
import { Flex, Text, Title } from '@gjensidige/builders-components';
import { Search } from '../shared/search';
import type { SearchProps } from '../shared/types';
import styles from '../shared/utils.module.less';

export const PageSearch = (props: SearchProps) => (
  <Flex
    center
    className={styles.marginBHeaders}
    gap="sm xl"
    layout={{ xs: 1, lg: 2 }}
  >
    <div>
      <Title as="h1" size="3" text={props?.phrases?.information?.title} />
      <Text size="lead">{props?.phrases?.information?.text}</Text>
    </div>
    <div>
      <Search {...props} phrases={{ ...props.phrases, information: {} }} />
    </div>
  </Flex>
);
